<template>
  <div pr-hold-left :style="bodyStyle">
    <div class="j" data-offset="0"></div>
    <div pr-hold-left-body class="stick-body">
      <div pr-hold-left-content :style="stickStyle">
        <slot />
      </div>
      <PrSplitLeft type="type0" :img="img" :title="title" :desc="desc" :subTitle="subTitle" :push="push" />
    </div>
  </div>
</template>

<script>
import PrSplitLeft from "@/views/components/PrSplitLeft";
import { applyRatio, getOffsetTop } from "@/utils";
import responsive from "@/utils/responsive";
export default {
  name: "PrHoldLeft",
  components: { PrSplitLeft },
  data() {
    return {
      bodyStyle: {},
      stickStyle: {},
      stickContainer: null,
      stickBody: null,
      push: 0,
      innerList: [],
      fixed: false,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    img: { type: String },
  },
  watch: {
    sv: "render"
  },
  methods: {
    inner(r) {
      this.push = r;
      applyRatio(this.innerList, r);
    },
    render() {
      if (!this.$el) return;
      const sv = this.sv;
      const d = sv - getOffsetTop(this.$el);
      const h = this.$el.offsetHeight - window.innerHeight;
      const t = this.sect === "sm" || this.sect === "md" ? 55 : 64;
      
      const maxMove = (this.sec4Content.offsetHeight + t) - window.innerHeight + t;
      let scrollMoveValue = (maxMove / 0.5) * this.push - maxMove;
      scrollMoveValue = scrollMoveValue < 0 ? 0 : scrollMoveValue > maxMove ? maxMove : scrollMoveValue;

      const viewMid = ((window.innerHeight - t)/2) - (this.scItem1.offsetHeight/2);
      const mtValue = viewMid * 0.75;
      this.scrollList.style.paddingTop = `${viewMid}px`;
      this.scrollList.style.paddingBottom = `${viewMid}px`;

      for (let i = 1; i < this.scrollItem.length; i++) {
        this.scrollItem[i].style.marginTop = `${mtValue}px`;
      }
      
      if (d < 0 || d > h) {
        scrollMoveValue = 0;

        if (d < 0) {
          this.sec4Split.classList.remove('pos-bottom');
          if (this.sec4HoldContent) this.sec4HoldContent.classList.remove('pos-bottom');
        } else if (d > h) {
          this.sec4Split.classList.add('pos-bottom');
          if (this.sec4HoldContent) this.sec4HoldContent.classList.add('pos-bottom');
        }

        if (this.fixed) {
          this.$el.appendChild(this.stickBody);
          this.fixed = false;
          this.$store.commit("setFix", false);
        }
      } else {
        if (!this.fixed) {
          this.stickContainer.appendChild(this.stickBody);
          this.fixed = true;
          this.$store.commit("setFix", true);
        }
      }

      if (d < -window.innerHeight * 2 || d > window.innerHeight * 2) return;
      this.inner(d / h);

      const ih = this.$el.offsetHeight - t;
      const stickyMarginLeft = this.push * 100 < 0 ? 0 : this.push * 100 > 50 ? 50 : this.push * 100;
      let stickyOpacity = (this.push * 5) - 1.5;
      stickyOpacity = stickyOpacity < 0 ? 0 : stickyOpacity > 1 ? 1 : stickyOpacity;

      this.bodyStyle = { height: ih + "px", paddingTop: t + "px" };
      this.stickStyle = { transform: "translateY(-"+ scrollMoveValue +"px)", marginLeft: stickyMarginLeft + "%", opacity: stickyOpacity };
    },
  },
  mounted() {
    this.stickContainer = document.querySelector(".stick-container");
    this.stickBody = this.$el.querySelector(".stick-body");
    this.sec4 = document.querySelector(".sec4");
    this.sec4Content = this.sec4.querySelector('.j');
    this.sec4Split = this.sec4.querySelector('[pr-split-left]');
    this.scrollList = this.sec4.querySelector('.scroll .list');
    this.scrollItem = this.sec4.querySelectorAll('.scroll .list .item');
    this.scItem1 = this.scrollItem[0];
    responsive.addListener(this.render);
    this.innerList = this.$el.querySelectorAll(
      "[pr-hold-left-content] [data-p]"
    );
    this.sec4HoldContent = this.$el.querySelector('[pr-hold-left-content]');
  },
  beforeDestroy() {
    responsive.removeListener(this.render);
    this.stickBody.parentNode.removeChild(this.stickBody);
    this.$store.commit("setFix", false);
  },
};
</script>

<style lang="less">
@import "~@/less/proj";

[pr-hold-left] {
  .j {
    .rel;
    .h(100%);
  }
}

[pr-hold-left-body] {
  [pr-split-left] {
    .bg {
      background-position: 100% center;
    }
  }

  [pr-hold-left-content] {
    .w(50%);
  }
}

@media (min-width: @screen-lg-min) {
  #sec4 {
    [pr-split-left] {
      &.is-fixed {
          .fix;
        }
    }
  }
}
</style>
